import TransferView from '@/views/TransferView.vue'
import { hasFeatureFlagActive } from '@/engine/featureFlags/featureFlags.state'
import { FEATURE_FLAGS } from '@/engine/featureFlags/flags'
import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'
import ROUTES from './routes'
import { TRANSFER_PATH, TRANSFER_TOKEN_QUERY } from './transferToken'

export default [
  {
    path: TRANSFER_PATH,
    name: ROUTES.TRANSFER,
    component: TransferView,
    beforeEnter: (to: RouteLocationNormalized) => {
      if (!hasFeatureFlagActive(FEATURE_FLAGS.CHARGER_TRANSFER_ACCEPTANCE)) {
        return { name: ROUTES.NOT_FOUND }
      }

      // Without a token there is nothing to show (for example after going back): the session guard
      // sends the user to the dashboard or to login.
      if (!to.query[TRANSFER_TOKEN_QUERY]) {
        return { name: ROUTES.DASHBOARD }
      }
    }
  }
] as RouteRecordRaw[]
